import i18next from "i18next";
import * as yup from "yup";

export function validation(types) {
  return yup.object().shape({
    description: yup
      .string()
      .required(i18next.t("validation.createMemories.description"))
      .min(3, "Minimum 3 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    title: yup
      .string()
      .required(i18next.t("validation.createMemories.title"))
      .min(3, "Minimum 3 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    date: yup.string().required(i18next.t("validation.createMemories.date")),
    type: yup.string().required("Timeline File is required"),
    timelineImage:
      types !== undefined && yup.string().required("Timeline File is required"),
  });
}
